export const profileConstants = {

    FETCH_MYPROFILE_REQUEST: 'FETCH_MYPROFILE_REQUEST',
    FETCH_MYPROFILE_SUCCESS: 'FETCH_MYPROFILE_SUCCESS',
    FETCH_MYPROFILE_FAILURE: 'FETCH_MYPROFILE_FAILURE',

    UPDATE_MYPROFILE_REQUEST: 'UPDATE_MYPROFILE_REQUEST',
    UPDATE_MYPROFILE_SUCCESS: 'UPDATE_MYPROFILE_SUCCESS',
    UPDATE_MYPROFILE_FAILURE: 'UPDATE_MYPROFILE_FAILURE',

    CLEAR_PROFILE: 'CLEAR_PROFILE',

    FETCH_MYPOINTS_REQUEST: 'FETCH_MYPOINTS_REQUEST',
    FETCH_MYPOINTS_SUCCESS: 'FETCH_MYPOINTS_SUCCESS',
    FETCH_MYPOINTS_FAILURE: 'FETCH_MYPOINTS_FAILURE',

    SHOW_AWARD_POPUP: 'SHOW_AWARD_POPUP',
    HIDE_AWARD_POPUP: 'HIDE_AWARD_POPUP',
    UPDATE_MYPOINTS_FROM_SOCKET: 'UPDATE_MYPOINTS_FROM_SOCKET',
    RESET_AWARD_FLAGS: 'RESET_AWARD_FLAGS'

};
